import styled from "@emotion/styled";
import NoLogOutHeaderPC from "components/layout/Header/NoLogIHeaderPC";
interface IPage {
  type?: string;
  children?: any;
  disable:boolean
}

const Layout = styled.div`
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 1;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const NoLoginPageWeb:React.FC<IPage> = ({ children, type, disable }) => {
  return (
    <Container>
      <NoLogOutHeaderPC disable={disable} />
      <Layout className={type}>{children}</Layout>
    </Container>
  )
};

export default NoLoginPageWeb;